import React from 'react'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import DisplayPagesSection from './DisplayPagesSection'
import FormProgramOverviewSubmenusContainer from '../../containers/forms/FormProgramOverviewSubmenusContainer'
import SaveStateButton from '../general/SaveStateButton'
import config from '../../config.json'

const PageWebsiteSubpagesPage = ({saveState, status, caps, closePagePath}) => (      
    <WrapperPageSimple pageTitleTransId={config.routes.subpages.transId} closePagePath={closePagePath}>
        <div className="website-page site-content">
            {caps.wpPagesGet && <div className="">
                <DisplayPagesSection 
                    transId="website_own_pages"
                    type='pages'
                />
            </div>}

            {caps.wpServicePagesGet && <div>
                <DisplayPagesSection 
                    transId="website_legal_pages"
                    type='servicePages'
                />
            </div>}

            {caps.wpDataUpdate && <div className="section-end">
                <FormProgramOverviewSubmenusContainer
                    transId='website_program_overview_submenus'
                    type="programSubmenus"
                />
            </div>}

            {caps.wpDataUpdate &&<div className="save-website-button">
                <SaveStateButton
                    saveState={saveState}
                    transId="save_button"
                    status={status}
                    cap='wpDataUpdate'
                />
            </div>}
        </div>
    </WrapperPageSimple>
)

export default PageWebsiteSubpagesPage  